import type {
  EsgPreference,
  EsgProfile,
} from 'src/tpbp-core/models/esg/esg.types'
import {
  ESG_PREFERENCES,
  ESG_PROFILES,
  type EsgPai,
  type EsgSfdrTaxonomy,
} from 'src/tpbp-core/models/esg/esg.types'
import type { EsgLabelApi, EsgPreferenceApi } from './esg.api.types'
import {
  ESG_LABELS_API,
  ESG_PREFERENCES_API,
  type EsgPaiApi,
} from './esg.api.types'

export function mapEsgPaiValuesApi(esgPaiApi: EsgPaiApi): EsgPai {
  return {
    greenhouseGases: esgPaiApi.values.esg_greenhouse_gases_value.exposure,
    biodiversity: esgPaiApi.values.esg_biodiversity_value.exposure,
    waterPollution: esgPaiApi.values.esg_water_pollution_value.exposure,
    hazardousWaste: esgPaiApi.values.esg_hazardous_waste_value.exposure,
    humanRights: esgPaiApi.values.esg_human_rights_value.exposure,
    genderEquality: esgPaiApi.values.esg_gender_equality_value.exposure,
  }
}

export function mapEsgSfdrTaxonomyApi(
  esgSfdrTaxonomy: EsgSfdrTaxonomy,
): EsgSfdrTaxonomy {
  return {
    label: esgSfdrTaxonomy.label,
    value: esgSfdrTaxonomy.value,
  }
}

const ESG_PREFERENCE_MAPPER = {
  [ESG_PREFERENCES_API.GENERIC]: ESG_PREFERENCES.GENERIC,
  [ESG_PREFERENCES_API.CUSTOM]: ESG_PREFERENCES.CUSTOM,
  [ESG_PREFERENCES_API.NEUTRAL]: ESG_PREFERENCES.NEUTRAL,
  [ESG_PREFERENCES_API.NONE]: ESG_PREFERENCES.NONE,
} as const satisfies Record<EsgPreferenceApi, EsgPreference>

export function mapEsgPreferenceApiToCore(
  esgPreferenceApi: EsgPreferenceApi | undefined,
): EsgPreference {
  return esgPreferenceApi
    ? ESG_PREFERENCE_MAPPER[esgPreferenceApi] || ESG_PREFERENCES.NONE
    : ESG_PREFERENCES.NONE
}

const ESG_PROFILE_MAPPER = {
  [ESG_LABELS_API.NEUTRAL]: ESG_PROFILES.NEUTRAL,
  [ESG_LABELS_API.INVOLVED]: ESG_PROFILES.INVOLVED,
  [ESG_LABELS_API.RESPONSIBLE]: ESG_PROFILES.RESPONSIBLE,
  [ESG_LABELS_API.COMMITTED]: ESG_PROFILES.COMMITTED,
  [ESG_LABELS_API.NONE]: ESG_PROFILES.NONE,
} as const satisfies Record<EsgLabelApi, EsgProfile>

export function mapEsgEsgProfileApiToCore(esgLabelApi: string): EsgProfile {
  return ESG_PROFILE_MAPPER[esgLabelApi as EsgLabelApi] || ESG_PROFILES.NONE
}

const ESG_CORE_TO_API_MAPPER = {
  [ESG_PROFILES.NEUTRAL]: ESG_LABELS_API.NEUTRAL,
  [ESG_PROFILES.INVOLVED]: ESG_LABELS_API.INVOLVED,
  [ESG_PROFILES.RESPONSIBLE]: ESG_LABELS_API.RESPONSIBLE,
  [ESG_PROFILES.COMMITTED]: ESG_LABELS_API.COMMITTED,
  [ESG_PROFILES.NONE]: ESG_LABELS_API.NONE,
} as const satisfies Record<EsgProfile, EsgLabelApi>

export function mapEsgEsgProfileCoreToApi(esgProfile: EsgProfile): EsgLabelApi {
  return ESG_CORE_TO_API_MAPPER[esgProfile] || ESG_LABELS_API.NONE
}
